import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

/**
 * BflHelpDialogComponent — read-only "How to use" guide for Best Fit Finder.
 * Opened as a nested Angular Material dialog from BestFitListComponent.
 * MatDialog properly stacks nested dialogs, so this renders above the parent.
 */
@Component({
    selector: 'app-bfl-help-dialog',
    templateUrl: './bfl-help-dialog.component.html',
    styleUrls: ['./bfl-help-dialog.component.css'],
    standalone: false
})
export class BflHelpDialogComponent {
    constructor(public dialogRef: MatDialogRef<BflHelpDialogComponent>) {}

    close(): void {
        this.dialogRef.close();
    }
}
